module.exports = __webpack_public_path__ + "media/site_templates/www.removingasbestos.net.au/images/splash-aac3941c1611f6d925c5b6fdaa0a28b4.jpg";